import React from 'react';
import { Card, CardContent, Grid, GridColumn } from 'telia-front-react';
import { NetflixAppCard } from './NetflixAppCard';
import { NetflixAppAdditionalInfo } from './NetflixAppAdditionalInfo';
import { NetflixAppViewRequirements } from './NetflixAppViewRequirements';
export const NetflixAppDetails = (props) => {
    const { productOfferingCode } = props;
    return (React.createElement(Grid, { equalHeight: true },
        React.createElement(GridColumn, { width: ['xs-12', 'lg-8'] },
            React.createElement(Card, null,
                React.createElement(CardContent, { background: 'neutral-bg-level-2' },
                    React.createElement(Grid, { equalHeight: true },
                        React.createElement(GridColumn, { width: ['xs-12', 'sm-5'] },
                            React.createElement(NetflixAppCard, { productOfferingCode: productOfferingCode })),
                        React.createElement(GridColumn, { width: ['xs-12', 'sm-7'] },
                            React.createElement(NetflixAppAdditionalInfo, null)))))),
        React.createElement(GridColumn, { width: ['xs-12', 'lg-4'] },
            React.createElement(NetflixAppViewRequirements, null))));
};
